// extracted by mini-css-extract-plugin
export var infoItem = "_p4-2";
export var title = "_p4-0";
export var value = "_p4-1";